import { cn } from '@/lib/utils';

interface OnboardingProgressBarProps {
  totalSteps: number;
  currentStep: number; // 1-indexed
}

export const OnboardingProgressBar = ({ totalSteps, currentStep }: OnboardingProgressBarProps) => (
  <div className="flex gap-1.5 w-full">
    {Array.from({ length: totalSteps }, (_, i) => (
      <div
        key={i}
        className={cn(
          'h-1 flex-1 rounded-full transition-colors duration-300',
          i < currentStep ? 'bg-sossiety-red' : 'bg-white/10'
        )}
      />
    ))}
  </div>
);
